import React from "react";
import {useTranslation} from "react-i18next";
import {
  AccentTextButton,
  CardPhoto,
  CtaArrowIcon,
  GradientCtaButton,
  InnerPanel,
  PanelText,
  PanelTitle,
  PhotoCard
} from "./onboardingStyles";

interface Props {
  onAnswer: (marketingConsent: boolean) => void;
}

function NewsletterStep({onAnswer}: Props) {
  const {t} = useTranslation();

  return (
    <PhotoCard>
      <CardPhoto src="/assets/images/onboarding/newsletter-photo.jpg" alt="" />
      <InnerPanel>
        <PanelTitle>{t("onboarding.stayInTheFlow")}</PanelTitle>
        <PanelText>{t("onboarding.stayInTheFlowText")}</PanelText>
        <GradientCtaButton small onClick={() => onAnswer(true)}>
          {t("onboarding.keepMeInTheLoop")}
          <CtaArrowIcon src="/assets/images/onboarding/arrow-cta.svg" alt="" />
        </GradientCtaButton>
        <AccentTextButton onClick={() => onAnswer(false)}>{t("onboarding.noThanks")}</AccentTextButton>
      </InnerPanel>
    </PhotoCard>
  );
}

export default NewsletterStep;
